export default __webpack_public_path__ + "static/media/img2.1e79549c.jpg";